<div style="align-items: center;">
    <ng-container *ngFor="let eachLetter of splittedPassword">
        <span class="dot">*</span>
    </ng-container>
</div>